import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { SignUpButton, TalkToFoundersButton } from '../CTAButtons';

type ProductFinalCtaProps = {
  tone: 'dark' | 'light';
  eyebrow: string;
  title: ReactNode;
  body: string;
  primaryLabel?: string;
  ghostLabel?: string;
  ghostTo?: string;
  ghostIsSales?: boolean;
  note: string;
};

export function ProductFinalCta({
  tone,
  eyebrow,
  title,
  body,
  primaryLabel = 'Sign Up',
  ghostLabel,
  ghostTo = '/',
  ghostIsSales = false,
  note,
}: ProductFinalCtaProps) {
  return (
    <section className={`final-cta band-${tone}`} id="cta">
      <div className="container">
        <div className="content-measure">
        <div className="cta-eyebrow">{eyebrow}</div>
        <h2>{title}</h2>
        <p>{body}</p>
        <div className="cta-actions">
          {ghostIsSales ? (
            <>
              <TalkToFoundersButton variant="primary">{ghostLabel}</TalkToFoundersButton>
              <SignUpButton variant="ghost">{primaryLabel}</SignUpButton>
            </>
          ) : (
            <>
              <SignUpButton variant="primary">{primaryLabel}</SignUpButton>
              {ghostLabel && (
                <Link to={ghostTo} className="btn btn-ghost">
                  {ghostLabel}
                </Link>
              )}
            </>
          )}
        </div>
        <div className="cta-note">{note}</div>
        </div>
      </div>
    </section>
  );
}
